import { Guardian } from './guardian';

/**
 * Classe que representa os chamados abertos pelo fale conosco.
 */
export class Called {

    /** ID da entidade no Firebase  */
    uuid: string;
    /** Nome */
    name: string;
    /** Email */
    email: string;
    /** Telefone */
    phone: string;
    /** XX */
    subject: string;
    /** XX */
    note: string;
    /** XX */
    date: any;
    /** XX */
    guardian: Guardian = null;

    /**
     * Instanciar um novo Chamado
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Called>) {
        Object.assign(this, init);
    }

    /**
     * Converter para object que o Firebase conheça
     */
    toFirebase(): object {
        return {
            name: this.name,
            email: this.email,
            phone: this.phone,
            subject: this.subject,
            note: this.note,
            guardian: this.guardian
        };
    }
}
